import type { MapStateToPropsFactory } from 'react-redux';
import { connect } from 'react-redux';
import type { SecondaryMarketQuoteRtForm } from 'state/secondaryMarket/realtimeQuote/realtimeQuoteForm';
import { makeGetSecondaryMarketRtFormValidationErrors } from 'state/secondaryMarket/realtimeQuote/realtimeQuoteForm/realTimeQuoteForm.selectors';
import { getSecondaryMarketRealtimeAstroProductFromTab } from 'state/secondaryMarket/referential/astroProduct/astroProduct.selectors';
import type { SecondaryMarketFormError } from 'state/secondaryMarket/shared/form/validationResults';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { secondaryMarketAstroProductFetchRequestedByTabIdThunk } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.thunks';
import { TabLoadingStatus } from 'state/workspaces/tabs/tabs.model';
import { getTabLoadingStatus } from 'state/workspaces/tabs/tabs.selector';

type OwnProps = Readonly<{
  tabId: string;
}>;

type StateProps = Readonly<{
  isLoading: boolean;
  hasFatalError: boolean;
  validationErrors: readonly SecondaryMarketFormError<SecondaryMarketQuoteRtForm>[];
}>;

type DispatchProps = {
  onRetryProductFetch: () => void;
};

const noValidationError: readonly [] = [];

export type QuoteRealtimeFormProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps: MapStateToPropsFactory<StateProps, OwnProps, AppState> = () => {
  const getSecondaryMarketRtFormValidationErrors = makeGetSecondaryMarketRtFormValidationErrors();

  return (state: AppState, { tabId }: OwnProps): StateProps => {
    const product = getSecondaryMarketRealtimeAstroProductFromTab(state, tabId);
    const loadingStatus = getTabLoadingStatus(state, tabId);
    if (product === undefined || loadingStatus === TabLoadingStatus.Loading) {
      return {
        isLoading: true,
        hasFatalError: false,
        validationErrors: noValidationError,
      };
    }

    if (product.hasError) {
      return {
        isLoading: false,
        hasFatalError: true,
        validationErrors: noValidationError,
      };
    }

    const validationErrors = getSecondaryMarketRtFormValidationErrors(state, tabId);
    return {
      isLoading: false,
      hasFatalError: false,
      validationErrors,
    };
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps => {
  return {
    onRetryProductFetch() {
      dispatch(secondaryMarketAstroProductFetchRequestedByTabIdThunk(tabId));
    },
  };
};
export const connectQuoteRealtimeForm = connect(mapStateToProps, mapDispatchToProps);
